import { Datareview, DatareviewStatus } from '@common/entities';
import {
  FREE_TEXT_FORM_KEYS,
  FreeTextFormFieldKey,
  OrganizationModel,
} from 'src/app/organization/@shared/organization.model';
import { transformToUpperSnakeCase } from 'src/app/@shared/utils/to-upper-snake-case';

export type DataReviewSource = Datareview;
export type FreeTextContentMap = { [key in FreeTextFormFieldKey]?: unknown };

export class DataReviewModel {
  public createdAt: string;
  public editor: string; // TODO: add to source
  public id: string;
  public notes?: string;
  public updatedAt: string;
  public organizationName: string;
  public organizationId: string;
  public status: DatareviewStatus;
  public statusIcon: string;
  public token: string;
  public organizationType: string;

  public changedOrganization: OrganizationModel;
  public organization: OrganizationModel;

  public freeTextContents: FreeTextContentMap = {}; // key value pairs of changed free text fields

  constructor(source: DataReviewSource) {
    this.id = source.id;
    this.createdAt = source.createdAt;
    this.notes = source.notes;
    this.updatedAt = source.updatedAt;
    this.organization = source.organization
      ? new OrganizationModel(source.organization)
      : null;

    this.changedOrganization = source.changedOrganization
      ? new OrganizationModel(source.changedOrganization)
      : null;

    this.organizationName = source.organization.name;

    if (this.organization.subType) {
      this.organizationType = `FORM.INPUT.SUB_TYPE.OPTIONS.${transformToUpperSnakeCase(this.organization.subType)}`;
    } else {
      this.organizationType = `FORM.INPUT.TYPE.OPTIONS.${transformToUpperSnakeCase(this.organization.type)}`;
    }

    this.organizationId = source.organizationId;
    this.status = source.status;
    this.token = source.token;
    if (source.reviewer) {
      this.editor = source.reviewer.email;
    }

    this.freeTextContents = this.getFreeTextContents(source.changedOrganization);
    this.setStatusIcon(source.status);
  }

  // eslint-disable-next-line class-methods-use-this
  private getFreeTextContents(changedOrganization: {}): FreeTextContentMap {
    const freeTextContents: FreeTextContentMap = {};

    for (const freeTextKey of FREE_TEXT_FORM_KEYS) {
      if (changedOrganization && changedOrganization.hasOwnProperty(freeTextKey)) {
        freeTextContents[freeTextKey] = changedOrganization[freeTextKey];
      }
    }

    return freeTextContents;
  }

  private setStatusIcon(status: DatareviewStatus): void {
    switch (status) {
      case 'to-be-reviewed':
        this.statusIcon = 'hourglass-outline';
        break;

      case 'accepted':
        this.statusIcon = 'checkmark-done-outline';
        break;

      case 'denied':
        this.statusIcon = 'close-outline';
        break;

      default:
        this.statusIcon = 'mail-unread-outline';
    }
  }
}
